import React from "react";
import S4SSimLoading from "./S4SSimLoading";

const ConsentCheckModal = () => {
  return <S4SSimLoading />;
};

export default ConsentCheckModal;
